import { Grid, Typography } from "@mui/material";
import { ExternalLink } from "ExternalLink";
import { ItemTypeCheckbox } from "components/FormControls/ItemTypeCheckbox";
import { achievementTypes } from "components/Layout/Achievement/helpers";
import { useMessage } from "hooks/intl";
import {
  AchievementRuleTypeUnion,
  FEAvailableAchievementType,
} from "types/achievements";
import { useStyles } from "../Rule";

interface Props {
  type: AchievementRuleTypeUnion;
  setFieldValue: (field: string, value: any) => void;
  activeRule: number;
}

export const RuleType = ({ type, setFieldValue, activeRule }: Props) => {
  const { message } = useMessage();
  const classes = useStyles({});

  return (
    <Grid container spacing={12}>
      {achievementTypes.map((item: FEAvailableAchievementType) => (
        <Grid item xs={6} key={item.type}>
          <ItemTypeCheckbox
            data-test-id={`rule-${activeRule}-type`}
            activeItem={type === item.type}
            label={message({ id: item.label })}
            description={message({
              id: item.descriptionText,
            })}
            onClick={() => {
              setFieldValue(`rules[${activeRule}].type`, item.type);
              setFieldValue(`rules[${activeRule}].conditions`, []);
              setFieldValue(
                `rules[${activeRule}].completeRule.onlyUniqueAttributeValues`,
                undefined,
              );
              setFieldValue(
                `rules[${activeRule}].completeRule.uniqueAttribute`,
                undefined,
              );
            }}
          />
        </Grid>
      ))}
      <Grid item xs={12} mt={-4}>
        <Typography className={classes.sectionInfo}>
          {message(
            { id: "achievementTypeLinksText" },
            {
              achievementTypes: (
                <ExternalLink path="https://help.openloyalty.io/main-features/achievements">
                  {message({
                    id: "achievementTypesLabel",
                  })}
                </ExternalLink>
              ),
              exampleAchievementConfiguration: (
                <ExternalLink path="https://help.openloyalty.io/sample-setups/sample-achievements">
                  {message({
                    id: "exampleAchievementConfigurationLabel",
                  })}
                </ExternalLink>
              ),
            },
          )}
        </Typography>
      </Grid>
    </Grid>
  );
};
